import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";

const SuccessDialog = ({ open, isSample, onClose, onContinue }) => {
  return (
    <Dialog open={open} onClose={onClose} disableEnforceFocus>
      <DialogContent>
        <h3 className="dialog-title">Your badges are ready to be printed</h3>
        <div>
          {isSample
            ? "A sample with the badges have been generated. You can check it out now 📄"
            : "A PDF with the badges have been generated. You can now print it with a printer 🖨️"}
        </div>
      </DialogContent>
      <DialogActions>
        <button className="primary" onClick={onContinue}>
          Got it
        </button>
      </DialogActions>
    </Dialog>
  );
};

export default SuccessDialog;
